import React from "react";

const badgeData = [
  {
    title: "Hope Giver",
    badge_color: "Bronze",
    min_payouts: 1,
  },
  {
    title: "Impact Starter",
    badge_color: "Silver",
    min_payouts: 5,
  },
  {
    title: "Circle Builder",
    badge_color: "Gold",
    min_payouts: 10,
  },
  {
    title: "Change Maker",
    badge_color: "Emerald",
    min_payouts: 15,
  },
  {
    title: "Community Champion",
    badge_color: "Sapphire",
    min_payouts: 20,
  },
  {
    title: "Influencer of Impact",
    badge_color: "Ruby",
    min_payouts: 25,
  },
  {
    title: "Legacy Leader",
    badge_color: "Diamond",
    min_payouts: 50,
  },
];

// Optional: Map badge color to Tailwind background + text color
const badgeColorMap = {
  Bronze: "bg-yellow-700 text-white",
  Silver: "bg-gray-400 text-white",
  Gold: "bg-yellow-400 text-black",
  Emerald: "bg-green-500 text-white",
  Sapphire: "bg-blue-700 text-white",
  Ruby: "bg-red-600 text-white",
  Diamond: "bg-indigo-800 text-white",
};

const BadgeTable = () => {
  return (
    <div className="p-4 lg:p-8">
      <div className="overflow-x-auto">
        <table className="min-w-full bg-transperent border border-gray-200 shadow-md rounded-lg  overflow-hidden">
          <thead className="bg-gray-100 text-left">
            <tr>
              <th className="pl-6 py-3 font-medium whitespace-nowrap text-gray-700">
                #
              </th>
              <th className="px-6 py-3 font-medium whitespace-nowrap text-gray-700 ">
                Title
              </th>
              <th className="px-6 py-3 font-medium whitespace-nowrap text-gray-700">
                Badge Color
              </th>
              <th className="px-6 py-3 font-medium whitespace-nowrap text-gray-700">
                Min Payouts
              </th>
            </tr>
          </thead>
          <tbody>
            {badgeData
              .slice()
              .reverse()
              .map((badge, index) => (
                <tr
                  key={index}
                  className="border-t border-gray-200 hover:bg-gray-50 transition"
                >
                  <td className="pl-6 py-4 whitespace-nowrap">{index + 1}</td>
                  <td className="px-6 py-4 whitespace-nowrap ">
                    {badge.title}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span
                      className={`px-3 py-1 rounded-full text-sm font-semibold ${
                        badgeColorMap[badge.badge_color]
                      }`}
                    >
                      {badge.badge_color}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {badge.min_payouts}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BadgeTable;
